// Google Analytics event tracking utility
export const trackEvent = (category, action, label = null, value = null) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Common event categories
export const EVENT_CATEGORIES = {
  GAME: 'Game',
  UI: 'UI',
  AUDIO: 'Audio',
  GALLERY: 'Gallery',
  SUPPORT: 'Support'
};

// Common event actions
export const EVENT_ACTIONS = {
  CLICK: 'click',
  TOGGLE: 'toggle',
  NAVIGATE: 'navigate',
  ENABLE: 'enable',
  DISABLE: 'disable'
};
